import React, { useEffect, useState } from "react";
import { Box, Select, MenuItem, TextField, Button, CircularProgress } from "@mui/material";

export default function WorkspaceSelector({ token, value, onChange }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newWs, setNewWs] = useState("");
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/workspaces`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => { setWorkspaces(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token, adding]);

  const handleAdd = async () => {
    if (!newWs.trim()) return;
    setAdding(true);
    await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/workspaces`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ name: newWs.trim() })
    });
    setNewWs("");
    setAdding(false);
  };

  return (
    <Box>
      {loading ? <CircularProgress size={24} /> : (
        <Select
          value={value || ""}
          onChange={e => onChange(e.target.value)}
          fullWidth
          size="small"
          sx={{ mb: 1 }}
        >
          {workspaces.map(ws => (
            <MenuItem key={ws} value={ws}>{ws}</MenuItem>
          ))}
        </Select>
      )}
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <TextField
          value={newWs}
          onChange={e => setNewWs(e.target.value)}
          placeholder="Add workspace"
          size="small"
          fullWidth
        />
        <Button onClick={handleAdd} disabled={!newWs.trim() || adding} variant="outlined" size="small">Add</Button>
      </Box>
    </Box>
  );
}
